import { Check } from "lucide-react";

export default function FeaturesSection({ t }) {
  return (
    <section id="features" className="py-20 bg-gray-50" data-testid="features-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{t.features.title}</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {t.features.sections.map((sec, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-testid={`feature-section-${i}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-[#CDA34F]/10 flex items-center justify-center shrink-0">
                  <sec.icon className="w-5 h-5 text-[#CDA34F]" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">{sec.title}</h3>
                  <p className="text-xs text-gray-500">{sec.desc}</p>
                </div>
              </div>
              <ul className="space-y-1.5 ml-1">
                {sec.items.map((item, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                    <Check className="w-4 h-4 text-[#CDA34F] shrink-0 mt-0.5" />{item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
